<template>
  <div>
    <div class="row">
      <div class="col-sm-4 mb-2">
        <button
          class="btn btn-info btn-sm"
          @click="create = true"
        >
          {{ $t('manage-master-data.create') }}
        </button>
      </div>
      <div class="col-sm-4 d-flex align-items-center justify-content-center mb-2">
        <small>{{ $t('pagination.show') }}</small>
        <select
          v-model="pagination.PageSize"
          class="form-control form-control-sm w-auto mx-2"
        >
          <option
            v-for="(size, s) in pageSizes"
            :key="s"
            :value="size"
          >
            {{ size }}
          </option>
        </select>
        <small>{{ $t('pagination.entries') }}</small>
      </div>
    </div>

    <data-table
      class="my-3"
      :fields="fields"
      :data="workStatuses"
    >
      <template #action="{ rowData }">
        <a
          class="text-info mx-2"
          :title="rowData.id"
          @click="editWorkStatus(rowData)"
        >
          <i class="fa fa-edit fa-lg" />
        </a>
        <a
          class="text-danger mx-2"
          :title="rowData.id"
          @click="confirmDelete(rowData)"
        >
          <i class="fa fa-trash fa-lg" />
        </a>
      </template>
    </data-table>

    <div class="d-flex flex-wrap justify-content-center justify-content-sm-between">
      <div class="mb-2">
        <pagination-info
          :page="workStatuses.currentPage"
          :page-size="workStatuses.pageSize"
          :shown="workStatuses.data.length"
          :total="workStatuses.totalData"
        />
      </div>

      <pagination
        ref="pagination"
        class="mb-2"
        @change="onPageChange"
      />
    </div>

    <create
      :shown="create"
      @close="create = false"
      @saved="saved"
    />

    <edit
      :shown="edit.modal"
      :work-status="edit.workStatus"
      @close="edit.modal = false"
      @saved="updated"
    />

    <modal
      :shown="success.modal"
      @close="success.modal = false"
    >
      <div class="p-5 text-center">
        <div>{{ success.text }}</div>
        <button
          class="btn btn-outline-info btn-sm mt-3"
          @click="success.modal = false"
        >
          OK
        </button>
      </div>
    </modal>

    <modal
      :shown="del.modal"
      @close="del.modal = false"
    >
      <div class="p-5 text-center">
        <div>
          {{
            $t(
              'manage-master-data.work-statuses.confirm-delete',
              { name: del.workStatus[`name${$i18n.locale.toUpperCase()}`] }
            )
          }}
        </div>
        <button
          class="btn btn-link text-decoration-none btn-sm mt-3"
          @click="del.modal = false"
        >
          {{ $t('manage-master-data.work-statuses.cancel') }}
        </button>
        <button
          class="btn btn-danger btn-sm mt-3"
          @click="deleteWorkStatus"
        >
          {{ $t('manage-master-data.work-statuses.delete') }}
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { PAGE_SIZES } from '@/fixtures'
import api from '@/utils/Api'
import DataTable from '@/components/DataTable'
import Modal from '@/components/Modal'
import PaginationInfo from '@/components/PaginationInfo'
import Pagination from '@/components/Pagination'
import Create from './WorkStatus/Create'
import Edit from './WorkStatus/Edit'

export default {
  components: {
    DataTable,
    Modal,
    PaginationInfo,
    Pagination,
    Create,
    Edit
  },

  data: () => ({
    fields: [
      { name: 'action', title: 'Tindakan', titleClass: 'text-center', dataClass: '__action' },
      { name: 'nameID', title: 'Work Status (ID)' },
      { name: 'nameEN', title: 'Work Status (EN)' },
      { name: 'company.name', title: 'Perusahaan' },
      { name: 'workLocation.name', title: 'Organisasi' },
      { name: 'createdBy', title: 'Dibuat Oleh' }
    ],
    pagination: {
      Page: 1,
      PageSize: 10
    },
    workStatuses: {
      data: []
    },
    create: false,
    edit: {
      modal: false,
      workStatus: {}
    },
    del: {
      modal: false,
      workStatus: {}
    },
    success: {
      modal: false,
      text: ''
    }
  }),

  computed: {
    pageSizes: () => PAGE_SIZES
  },

  watch: {
    'pagination.PageSize' () {
      this.pagination.Page = 1
      this.fetch()
    }
  },

  created () {
    this.fetch()
  },

  methods: {
    async fetch () {
      const { data } = await api.workStatuses.list({
        ...this.pagination
      })
      this.workStatuses = data
      this.$refs.pagination.setPaginationData({
        total: data.totalData,
        per_page: data.pageSize,
        current_page: data.currentPage,
        last_page: data.totalPage
      })
    },
    async deleteWorkStatus () {
      await api.workStatuses.delete(this.del.workStatus.id)
      this.del.modal = false
      this.success = {
        modal: true,
        text: this.$t(
          'manage-master-data.work-statuses.success-delete',
          { name: this.del.workStatus[`name${this.$i18n.locale.toUpperCase()}`] }
        )
      }
      this.fetch()
    },
    editWorkStatus (workStatus) {
      this.edit = {
        modal: true,
        workStatus: { ...workStatus }
      }
    },
    saved () {
      this.fetch()
      this.create = false
      this.success = {
        modal: true,
        text: this.$t('manage-master-data.work-statuses.success-add')
      }
    },
    updated () {
      this.fetch()
      this.edit.modal = false
      this.success = {
        modal: true,
        text: this.$t(
          'manage-master-data.work-statuses.success-update',
          { name: this.edit.workStatus[`name${this.$i18n.locale.toUpperCase()}`] }
        )
      }
    },
    confirmDelete (workStatus) {
      this.del = {
        modal: true,
        workStatus
      }
    },
    onPageChange (page) {
      this.pagination.Page = page
      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.__action) {
  min-width: 100px;
  max-width: 100px;
  text-align: center;
}
</style>
